





























































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import DisplayFieldCode from '@shared/components/displays/display-field-code/display-field-code.vue';
import DisplayFieldDate from '@shared/components/displays/display-field-date/display-field-date.vue';
import DisplayFieldText from '@shared/components/displays/display-field-text/display-field-text.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import DisplayFieldBookingEventSelect from '@shared/components/displays/display-field-booking-event-select/display-field-booking-event-select.vue';
import DisplayFieldTimeRange from '@shared/components/displays/display-field-time-range/display-field-time-range.vue';
import DisplayFieldDateRange from '@shared/components/displays/display-field-date-range/display-field-date-range.vue';
import { Contract } from '@contracts/interfaces/contract';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import TableMock from '@shared/components/mocks/table-mock/table-mock.vue';
import moment from 'moment';

@Component({
  name: 'bpc-manage-contract-bookings-table',
  components: {
    'bpc-display-field-code': DisplayFieldCode,
    'bpc-display-field-date': DisplayFieldDate,
    'bpc-display-field-date-range': DisplayFieldDateRange,
    'bpc-display-field-text': DisplayFieldText,
    'bpc-display-field-badge': DisplayFieldBadge,
    'bpc-display-field-booking-event-select': DisplayFieldBookingEventSelect,
    'bpc-display-field-time-range': DisplayFieldTimeRange,
    'bpc-table-mock': TableMock,
  },
})
export default class ManageContractBookingsTable extends Vue {
  @Prop(Object) readonly contract: Contract;

  // DATA
  loading: boolean = false;
  bookings = [];
  bookingFields = [
    {
      key: 'code',
      label: 'bookings.bookings.code.label',
    },
    {
      key: 'date_range',
      label: 'bookings.bookings.date_range.label',
    },
    {
      key: 'resources',
      label: 'bookings.bookings.resources.label',
    },
    {
      key: 'status',
      label: 'bookings.bookings.status.label',
    },
    {
      key: 'show_details',
      label: 'bookings.booking_events.action.label',
    },
  ];
  bookingEventFields = [
    {
      key: 'code',
      label: 'bookings.booking_events.code.label',
    },
    {
      key: 'date',
      label: 'bookings.booking_events.date.label',
    },
    {
      key: 'time_range',
      label: 'bookings.booking_events.time_range.label',
    },
    {
      key: 'resource.name',
      label: 'bookings.booking_events.resource.name.label',
    },
    {
      key: 'status',
      label: 'bookings.booking_events.status.label',
    },
    {
      key: 'actions',
      label: 'bookings.booking_events.action.label',
    },
  ];
  bookingStatusValueToLabel: object[] = [
    {
      label: 'global.fields.status.cancelled.label',
      value: 'cancelled',
    },
    {
      label: 'global.fields.status.confirmed.label',
      value: 'confirmed',
    },
    {
      label: 'global.fields.status.requested.label',
      value: 'requested',
    },
    {
      label: 'global.fields.status.draft.label',
      value: 'draft',
    },
  ];
  bookingStatusValueToVariant: object[] = [
    {
      value: 'confirmed',
      variant: 'success',
    },
    {
      value: 'requested',
      variant: 'info',
    },
    {
      value: 'draft',
      variant: 'info',
    },
    {
      value: 'cancelled',
      variant: 'danger',
    },
  ];

  mounted() {
    if (this.contract.status === 'proposed') {
      this.bookingFields.splice(3, 1);
      this.bookingEventFields.splice(4, 1);
    }
    this.loadContractBookings();
  }

  loadContractBookings() {
    const bookingIds = this.contract['bookings'].map(booking => {
      return booking['id'];
    });

    // If the contract contain bookings, load the booking events corresponding to each one
    if (bookingIds.length) {
      this.loading = true;
      const queryConfig = {
        params: {
          contract_id: this.contract.id,
          per_page: -1,
          include: ['resource', 'conflicts'],
          relationFields: ['resource.id', 'resource.name'],
        },
      };
      this.$bpcApi
        .get(this.$bpcApiRouteHelper.getEntityPath('booking-event'), queryConfig)
        .subscribe(
          (res: BPCGenericApiResponse) => {
            console.log(res);
            this.contract['bookings'].forEach(booking => {
              // Set the action "request" by default for all booking events with status "draft" when the contract is proposed
              if (this.contract.status === 'proposed') {
                res.data.forEach(event =>
                  event.status === 'draft'
                    ? (event.action = 'request')
                    : (event.action = 'nothing'),
                );
              }

              // Set the loaded booking events in the corresponding booking of the contract.
              const bookingEvents = res.data.map(event => ({
                ...event,
                date: this.parseEventDate(event.date),
              }));
              booking['bookingEvents'] = bookingEvents.filter(
                event => event.booking_id === booking['id'],
              );
            });
            this.bookings = this.contract['bookings'];
            this.loading = false;
          },
          error => {
            console.log(error);
            this.loading = false;
          },
        );
    }
  }

  parseEventDate(date) {
    const locale = this.getLang() === 'be' ? 'fr' : this.getLang();

    return moment(date)
      .locale(locale)
      .format('ddd DD/MM/YYYY');
  }

  getLang() {
    const defaultLang = process.env.VUE_APP_DEFAULT_LANG || 'fr';
    return localStorage.getItem('lang') || this.$store.getters['auth/userLang'] || defaultLang;
  }
}
